import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { of } from 'rxjs';
import { catchError, exhaustMap, filter, tap } from 'rxjs/operators';

import { Block } from '@core/models/block/block.model';
import { SubSink } from '@core/utils/subsink';

import { AuthService } from '@app/auth/services/auth.service';
import { ButtonHandlerService } from '@core/services/button-handler.service';

import { SnackBarMessageComponent } from '@shared/components/snack-bar-message.component';
import { FormService } from '@modules/creator/components/special-block/forms/services/form.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-register-form',
    encapsulation: ViewEncapsulation.None,
    template: `
    <form [formGroup]="formGroup">
      <div app-block-container [children]="specialBlock.children"></div>
    </form>
  `,
    providers: [FormService],
    standalone: false
})
export class RegisterFormComponent implements OnInit, OnDestroy {
  @Input() specialBlock: Block;
  formGroup = this._fs.formGroup;
  private subSink = new SubSink();

  constructor(private _router: Router,
    private _snackBar: MatSnackBar,
    private _fs: FormService,
    private _as: AuthService,
    private _buttonHandlerService: ButtonHandlerService,
    private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.formGroup.addControl(
      'accept_privacy_policy_regulations',
      new UntypedFormControl(true)
    );

    this.subSink.sink = this._buttonHandlerService.click$
      .pipe(
        tap(() => this.formGroup.markAllAsTouched()),
        filter(() => this.formGroup.valid),
        exhaustMap(({ actionData: { path } }) =>
          this._as.register(path, this.formGroup.getRawValue()).pipe(
            catchError(({ ok, error }) => {
              this._fs.setFormErrors(error.errors);
              return of(ok);
            })
          )
        ),
        filter((result: boolean | object) => !!result)
      )
      .subscribe(
        () => {
          // pobierz tłumaczenie i pokaż snackbar
          this.translate
            .get('registerForm.success')
            .subscribe((translated: string) => {
              this._snackBar
                .openFromComponent(SnackBarMessageComponent, {
                  data: translated,
                })
                .afterDismissed()
                .subscribe(() => this._router.navigate(['/']));
            });
        },
        () => {
          this.translate.get('registerForm.error').subscribe((translated: string) => {
            this._snackBar.openFromComponent(SnackBarMessageComponent, {
              data: translated,
            });
          });
        }
      );
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
